import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function KongoExpedition() {
  const dateTexts = ['1899年', '7月'];
  const title = 'ハイタワー三世、コンゴ河遠征';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2021/12/CIMG2795.jpg'
  const description = (
    <>
      <a href='/harrison-hightower-iii'>
        {'ハリソンハイタワー三世'}
      </a>
      {'がアフリカ探検旅行・コンゴ河遠征へ出発する。この遠征でコンゴ河に住むムトゥンドゥ族からシリキ・ウトゥンドゥという偶像を強奪する。'}
    </>
  );


  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
    />
  );
}

export default KongoExpedition;
